import React from 'react';
import classNames from 'classnames';
import { useT } from 'talkr';
import s from './inputStyle.module.scss';

function InputStyle (props) {
	const {
		valueF, valueI, valueC, onChangeAction, isThisCurrentStep,
		actionOnFocus, isDoubleInput, isOnFocusF, isOnFocusI, isOnFocusC, inputStyle
	} = props;
	const { T } = useT();
	const tempClass = (classString) => `${inputStyle}_${classString}`;

	return (
		<>
			<div data-prevent-from-blur className={classNames(s[tempClass('doubleContainer')], !isDoubleInput && s.invisibleOpacity)}>
				<div data-prevent-from-blur className={s[tempClass('doubleContainer_item')]}>
					<input
						data-prevent-from-blur
						className={`${s[tempClass('value')]}`}
						id="heightF"
						type="number"
						pattern="\d*"
						value={valueF}
						onFocus={(e) => actionOnFocus(e)}
						onChange={onChangeAction}
						placeholder="0"
						tabIndex={isThisCurrentStep ? -1 : ''}
					/>
					<label htmlFor="heightF" data-prevent-from-blur className={classNames(s[tempClass('doubleContainer_unit')], isOnFocusF && s[tempClass('doubleContainer_unit_focus')])}>
						{T('value_ft')}</label>
				</div>
				<div data-prevent-from-blur className={s[tempClass('doubleContainer_item')]}>
					<input
						data-prevent-from-blur
						className={`${s[tempClass('value')]}`}
						id="heightI"
						type="number"
						pattern="\d*"
						value={valueI}
						onFocus={(e) => actionOnFocus(e)}
						onChange={onChangeAction}
						placeholder="0"
						tabIndex={isThisCurrentStep ? -1 : ''}
					/>
					<label htmlFor="heightI" data-prevent-from-blur className={classNames(s[tempClass('doubleContainer_unit')], isOnFocusI && s[tempClass('doubleContainer_unit_focus')])}>
						{T('value_in')}</label>
				</div>
			</div>
			<div data-prevent-from-blur className={classNames(s[tempClass('singleContainer')], isDoubleInput && s.invisibleOpacity)}>
				<input data-prevent-from-blur className={classNames(s[tempClass('value')], isOnFocusC && s[tempClass('doubleContainer_unit_focus_c')])} id="heightC" type="number" pattern="\d*" value={valueC} onFocus={(e) => actionOnFocus(e)} onChange={onChangeAction} tabIndex={isThisCurrentStep ? -1 : ''} />
			</div>
		</>
	);
}

export default InputStyle;
